import React from 'react';
import I18n from 'modules/i18n';
import styles from './HeaderButton.module.scss';

interface HeaderButtonProps {
  frameworkNoun: 'Benchmarks' | 'Standards';
  href: string;
  stateCode: string | null;
  statefaceIcon: string | null;
}

export const HeaderButton = ({
  frameworkNoun, href, stateCode, statefaceIcon,
}: HeaderButtonProps) => {
  const labelKey = frameworkNoun === 'Standards' ? 'view_state_standards' : 'view_state_benchmarks';

  return (
    <button
      className={`btn btn--white ${styles.headerButton}`}
      type="button"
      onClick={() => !window.location.href.match(href) && window.location.assign(href)}
    >
      <div className={styles.buttonContent}>
        {statefaceIcon && <span aria-hidden="true" className={`${styles.stateIcon} ${statefaceIcon}`} />}
        <span>{I18n.t(labelKey, { state: stateCode })}</span>
      </div>
    </button>
  );
};

export default HeaderButton;
